import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import Slide from "@material-ui/core/Slide";
import Divider from "@material-ui/core/Divider";

import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import LaunchOutlinedIcon from "@material-ui/icons/LaunchOutlined";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";

import ChildCareOutlinedIcon from "@material-ui/icons/ChildCareOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";

import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";

import ClassAddDetails from "./ClassAddDetails";
import ClassAddBooking from "./ClassAddBooking";
import ClassAddOptions from "./ClassAddOptions";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 100;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const ClassAdd = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const hasOptions = true;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const serviceOptions = [
		{
			duration: "Free trial offer",
			detail: "New students only",
			price: "Free",
		},
		{
			duration: "Drop-in",
			detail: "9 dates remaining • Packs available",
			price: "$25 / class",
		},
		{
			duration: "Monthly pricing",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$65 / month",
		},
		{
			duration: "Remaining schedule",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$250",
		},
		{
			duration: "Full schedule",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$350",
		},
	];

	const [selectedOption, setSelectedOption] = useState(null);

	const handleRadioChange = (event) => {
		setSelectedOption(event.target.value);
	};

	// Close dialog

	const handleCloseClick = () => {
		onClose();
	};

	// ClassAddDetails

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const toggleDialog = () => {
		setIsDialogOpen(!isDialogOpen);
	};

	// ClassAddBooking

	const [isBookingDialogOpen, setIsBookingDialogOpen] = useState(false);

	const toggleBookingDialog = () => {
		setIsBookingDialogOpen(!isBookingDialogOpen);
	};

	const itemsToShow = fullScreen ? 2 : 3;

	const itemData = [
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--XXgODZkV--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/5JhoFGHSQ/IMG_2058.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--C2KGRIZd--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/b6hxCnRM/6176e93491123974bf53a923_1_pictures.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--Y9udUVtL--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/BSYJytWI7_/IMG_2056.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--Md7vbIBI--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/b6hxCnRM/6176e93491123974bf53a923_3_pictures.jpg",
		},
	];

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			//maxWidth={"sm"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					{isElevated && (
						<Box
							fontSize={20}
							fontWeight={600}
							className={classes.serviceAddTitle}
						>
							Toddler and Me Yoga: Songs and Sensory Play
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				dividers={hasOptions}
				style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				<Box mb={8}>
					<ImageList rowHeight={120} gap={8} cols={fullScreen ? 2 : 3}>
						{itemData.slice(0, itemsToShow).map((item) => (
							<ImageListItem
								key={item.img}
								cols={item.cols || 1}
								className={classes.imageList}
								classes={{ item: classes.imageList }}
							>
								<img src={item.img} />
							</ImageListItem>
						))}
					</ImageList>
				</Box>
				<Box
					fontWeight={600}
					fontSize={28}
					pb={4}
					maxWidth={"90%"}
					lineHeight={1.3}
				>
					Toddler and Me Yoga
				</Box>
				<Box py={4}>
					<Box display={"flex"} flexDirection={"column"} style={{ gap: 8 }}>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<ChildCareOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Ages:</div> 2
								&ndash; 4 yrs&nbsp;&nbsp;&bull;&nbsp;&nbsp;Adult participation
								required
							</div>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<DateRangeOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Dates:</div> Mar
								17, 2024 &ndash; May 5, 2024&nbsp;&nbsp;&bull;&nbsp;&nbsp;8
								classes
							</div>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<AccessTimeOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Time:</div> Mon
								&ndash; Fri&nbsp;&nbsp;&bull;&nbsp;&nbsp;7:00 AM &ndash; 5:00 PM
								CST
							</div>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<GroupOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Capacity:</div>
								75 students
							</div>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<PersonOutlineOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>
									Instructor:
								</div>{" "}
								Jaclyn M.
							</div>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<RoomOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Location:</div>
								8330 Long Point Rd Unit E Houston, TX 77055
							</div>
							<Tooltip
								enterDelay={200}
								title="Get directions"
								arrow
								TransitionComponent={Zoom}
								placement={"top"}
							>
								<a href="xxx" target="_blank" style={{ display: "flex" }}>
									<LaunchOutlinedIcon color="primary" fontSize="small" />
								</a>
							</Tooltip>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<MonetizationOnOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Price:</div>{" "}
								From $49
							</div>
						</Box>
					</Box>
					{/* <Box fontSize={17} my={5} fontWeight={600}>
						from $48
					</Box> */}
					{/* <Box my={8}>
						<Divider light />
					</Box> */}
					<Box my={8}>
						<Divider light />
					</Box>

					<ClassAddDetails />
					{/* <div className={classes.showMoreText}>
							All skill-levels welcome. Our classes are developmentally
							appropriate for the ages listed. We advise all children to be the
							minimum age for the class by the season start date to set them up
							for success in our program. We advise all children to be the
							minimum age for the class by the season start date to set them up
							for success in our program. We advise all children to be the
							minimum age for the class by the season start date to set them up
							for success in our program.
						</div>
						<Link color="primary" onClick={toggleDialog}>
							Show more
						</Link>
						<ClassAddDetails open={isDialogOpen} onClose={toggleDialog} /> */}

					{/* {hasOptions && (
						<>
							<Box my={8}>
								<Divider light />
							</Box>
							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								mb={2}
							>
								<div>
									<Box fontSize={22} fontWeight={600} mb={1}>
										Select an option
									</Box>
									<Box color={"grey.600"} fontSize={15}>
										Choose one
									</Box>
								</div>

								<Box fontSize={14} fontWeight={600} color={"#c31c3b"}>
									2 spots left!
								</Box>
							</Box>
							<List>
								{serviceOptions.map((option, index) => (
									<ListItem
										key={index}
										button
										onClick={() => setSelectedOption(option.duration)}
										classes={{
											root: classes.listItem,
											button: classes.listButton,
											container: classes.listItemContainer,
										}}
										disableGutters
									>
										<ListItemText
											classes={{
												primary: classes.listPrimary,
												secondary: classes.listSecondary,
												multiline: classes.listMultiline,
											}}
											primary={option.duration}
											secondary={
												<>
													<Box mb={3}>{option.detail}</Box>
													<Box color={"#222 !important"} fontWeight={600}>
														{option.price}
													</Box>
												</>
											}
										/>
										<ListItemSecondaryAction>
											<Radio
												color="primary"
												edge="end"
												checked={selectedOption === option.duration}
												onChange={handleRadioChange}
												value={option.duration}
											/>
										</ListItemSecondaryAction>
									</ListItem>
								))}
							</List>
						</>
					)} */}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: 24 }}>
				<Box
					display={"flex"}
					flexDirection={"row"}
					justifyContent={"space-between"}
					width={"100%"}
					m={"0 auto"}
					maxWidth={600}
				>
					{/* <Box flexBasis={"48%"}>
						<Button
							fullWidth
							size={"large"}
							//onClick={declineOnClickHandler}
							variant="outlined"
							disableElevation
						>
							Cancel
						</Button>
					</Box> */}
					{/* <Box flexBasis={"48%"}> */}
					<Button
						fullWidth
						onClick={toggleBookingDialog}
						size={"large"}
						variant="contained"
						color="primary"
						disableElevation
						//disabled={hasOptions ? !selectedOption : false}
					>
						Register
					</Button>

					<ClassAddOptions
						open={isBookingDialogOpen}
						onClose={toggleBookingDialog}
					/>
					{/* </Box> */}
				</Box>
			</DialogActions>
		</Dialog>
	);
};

ClassAdd.propTypes = {};
export default ClassAdd;
